import type { YDocWriteRecord } from '../generated/nodeDataTypes'

export type VideoGeneratorAudioField =
  | 'in_generate_audio'
  | 'in_provider_generate_audio'

export type VideoGeneratorAudioFieldValue = boolean | null | undefined

export interface VideoGeneratorAudioDisplaySettings {
  providerGenerateAudio: boolean
}

export interface VideoGeneratorCreationAudioDefaultOptions {
  explicitData?: YDocWriteRecord
}

export interface VideoGeneratorAudioReader {
  has(key: VideoGeneratorAudioField): boolean
  get(key: VideoGeneratorAudioField): VideoGeneratorAudioFieldValue
}

export function videoGeneratorCreationAudioDefaults(
  _options: VideoGeneratorCreationAudioDefaultOptions = {},
): YDocWriteRecord {
  return {
    in_provider_generate_audio: true,
  }
}

export const VIDEO_GENERATOR_CREATION_AUDIO_DEFAULTS: YDocWriteRecord =
  videoGeneratorCreationAudioDefaults()

export function resolveVideoGeneratorAudioDisplaySettings(
  reader: VideoGeneratorAudioReader,
): VideoGeneratorAudioDisplaySettings {
  const rawProviderGenerateAudio = reader.get('in_provider_generate_audio')

  return {
    providerGenerateAudio:
      typeof rawProviderGenerateAudio === 'boolean' ? rawProviderGenerateAudio : true,
  }
}

export function withVideoGeneratorCreationAudioDefaults(
  nodeType: string,
  data: YDocWriteRecord,
  options: VideoGeneratorCreationAudioDefaultOptions = {},
): YDocWriteRecord {
  if (nodeType !== 'videoGenerator' && nodeType !== 'video_generator') {
    return data
  }
  const audioControlSource = options.explicitData ?? data
  const hasAudioControl =
    Object.prototype.hasOwnProperty.call(audioControlSource, 'in_provider_generate_audio') ||
    Object.prototype.hasOwnProperty.call(audioControlSource, 'in_generate_audio')
  if (hasAudioControl) {
    return data
  }
  const defaults = videoGeneratorCreationAudioDefaults()
  return {
    ...data,
    ...defaults,
  }
}
